import React, { useState } from 'react';
import styled from 'styled-components';
import "./contact.css";

const Wrapper = styled.section`
  padding: 5rem 0 3rem 0;

  .contact-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    background-color: rgba(255, 166, 0, 0.155);
  }

  .contact-inputs {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .contact-form {
    text-align: center;
    max-width: 40rem;
    min-width: 30rem;
    margin: auto;
    padding: 10px 50px;
    background-color: rgba(42, 28, 2, 0.155);
    flex: 1;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
  }

  .checkbox-label input {
    margin-right: 15px;
  }

  .service-label {
    font-weight: bold;
  }

  h1 {
    font-family: "PT Serif", serif;
    font-weight: 700;
    font-style: normal;
    text-decoration: underline;
    text-align: center;
    color: rgb(31, 21, 2);
  }

  /* Media Queries for Responsiveness */
  @media (max-width: 1024px) {
    .contact-body {
      flex-direction: column;
    }

    .contact-map {
      width: 100%;
      margin: 0 auto 1rem auto;
    }

    .contact-form {
      width: 100%;
      padding: 20px;
    }
  }

  @media (max-width: 768px) {
    .contact-map iframe {
      width: 100%;
      height: 400px;
    }

    .contact-form {
      padding: 20px;
      min-width: unset;
      max-width: 100%;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 24px;
    }

    label {
      font-size: 16px;
    }

    .contact-form input, .contact-form textarea {
      font-size: 16px;
    }

    .contact-form {
      padding: 10px;
    }
  }
`;

const Contact = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedOptions([...selectedOptions, value]);
    } else {
      setSelectedOptions(selectedOptions.filter((option) => option !== value));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Selected options:', selectedOptions);
    // Handle form submission
  };

  return (
    <Wrapper>
      
      <div className='contact-body'>
        <div className='contact-map'>
          <iframe
            title="Contact form"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d810.2644697803305!2d73.05717680501164!3d19.309695936375014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bd1602401381%3A0x7929d956bc76b69b!2sAakash%20Apartment!5e0!3m2!1sen!2sin!4v1717786918936!5m2!1sen!2sin"
            width="700"
            height="650"
            // style={{ border: 1 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>


        <div className='contact-form'>
          <h2>Feel Free to Contact Us</h2>
          <form action="https://formspree.io/f/xrgnnbpk" method="POST" className='contact-inputs'>
            <input type="text" name="name" placeholder='Name *' autoComplete='off' required />
            <input type="text" name="company" placeholder='Company' autoComplete='off' />
            <input type="email" name="email" placeholder='Email *' autoComplete='off' required />
            <input type="text" name="subject" id="" placeholder='Service you prefer' autoComplete='off' required/>
            {/* <div>
              <span className="service-label">Service:</span>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="Electric Insulation Coating"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('Electric Insulation Coating')}
                />
                Electric Insulation Coating
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="High Reflective Coating and Paint"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('High Reflective Coating and Paint')}
                />
                High Reflective Coating and Paint
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="Anticorrosing Protective Coatings"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('Anticorrosing Protective Coatings')}
                />
                Anticorrosing Protective Coatings
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="High End Industrial Flooring"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('High End Industrial Flooring')}
                />
                High End Industrial Flooring
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="Antiskid Car Parking Flooring"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('Antiskid Car Parking Flooring')}
                />
                Antiskid Car Parking Flooring
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="Waterproofing Systems"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('Waterproofing Systems')}
                />
                Waterproofing Systems
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  value="Floorcoat"
                  onChange={handleCheckboxChange}
                  checked={selectedOptions.includes('Floorcoat')}
                />
                Floorcoat
              </label>
            </div> */}
            <textarea name="message" placeholder='Message' cols="50" rows="4" autoComplete='off' required></textarea>
            <button className="btn btn-success" style={{ height: '2.5rem', width: '10rem' }} type="submit">Send</button>
          </form>
        </div>
      </div>
    </Wrapper>
  );
};

export default Contact;
